export default __webpack_public_path__ + "static/media/twitter-icon.66c62232.svg";